"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _component = _interopRequireDefault(require("@loadable/component"));
var _clsx = _interopRequireDefault(require("clsx"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _Container = _interopRequireDefault(require("@material-ui/core/Container"));
var _useLink = _interopRequireDefault(require("@micado-digital/react-link/hooks/useLink"));
var _useSystemLinks = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useSystemLinks"));
var _PageContext = _interopRequireDefault(require("@micado-digital/react-ui/context/PageContext"));
var _fireCustomEvent = _interopRequireDefault(require("@micado-digital/react-ui/utils/fireCustomEvent"));
var _CartContext = _interopRequireDefault(require("../../context/CartContext"));
var _checkIfPaymentSelected = _interopRequireDefault(require("../../utils/checkIfPaymentSelected"));
var _useIsLoggedIn = _interopRequireDefault(require("../../hooks/useIsLoggedIn"));
var _Addresses = _interopRequireDefault(require("./Addresses"));
var _Login = _interopRequireDefault(require("../Login01"));
var _Overview = _interopRequireDefault(require("./Overview"));
var _PaymentMethods = _interopRequireDefault(require("./PaymentMethods"));
var _Checkout = _interopRequireDefault(require("./Checkout01.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Error = (0, _component.default)(() => import("../../components/Cart/Error"));
const Preloader = (0, _component.default)(() => import("../../components/Preloader"));
const Checkout01 = _ref => {
  var _systemLink;
  let {
    defaultLang = "de"
  } = _ref;
  const [pageData] = (0, _react.useContext)(_PageContext.default);
  const {
    lang: pageDataLang
  } = pageData || {};
  const {
    cart
  } = (0, _react.useContext)(_CartContext.default);
  const {
    address,
    isGuest = false,
    items = [],
    paymentMethods = [],
    _loading = false
  } = cart || {};
  const [lang, setLang] = (0, _react.useState)(defaultLang);
  const navigate = (0, _useLink.default)();
  const systemLink = (0, _useSystemLinks.default)();
  const isLoggedIn = (0, _useIsLoggedIn.default)();
  const css = (0, _Checkout.default)();
  const shopUrl = (_systemLink = systemLink("shop")) !== null && _systemLink !== void 0 ? _systemLink : "/";
  (0, _react.useEffect)(() => {
    if (!pageDataLang) return;
    setLang(pageDataLang);
  }, [pageDataLang]);
  (0, _react.useEffect)(() => {
    var _cart$items;
    const isTriggered = sessionStorage.getItem("mco-ski-shop-begin-checkout");
    if ((0, _isEmpty.default)(cart) || isTriggered === "true") return;
    let totalAmount = 0;
    const items = cart === null || cart === void 0 || (_cart$items = cart.items) === null || _cart$items === void 0 ? void 0 : _cart$items.map(item => {
      const {
        price: {
          amount = 0
        } = {},
        title
      } = item;
      totalAmount += amount;
      return {
        item_name: title,
        price: amount,
        quantity: 1
      };
    });
    (0, _fireCustomEvent.default)("begin_checkout", {
      currency: "EUR",
      items,
      value: totalAmount
    });
    sessionStorage.setItem("mco-ski-shop-begin-checkout", "true");
  }, [cart]);
  const handleShopClick = () => {
    navigate(shopUrl);
  };
  if (_loading) {
    return /*#__PURE__*/_react.default.createElement(Preloader, null);
  }
  if ((0, _isEmpty.default)(items)) {
    return /*#__PURE__*/_react.default.createElement(_Container.default, {
      className: (0, _clsx.default)(css.checkout, "mco-shop-checkout"),
      maxWidth: "lg"
    }, /*#__PURE__*/_react.default.createElement(Error, {
      lang: lang,
      onClick: handleShopClick
    }));
  }
  if ((isGuest || isLoggedIn) && (0, _isEmpty.default)(address)) {
    return /*#__PURE__*/_react.default.createElement(_Container.default, {
      className: (0, _clsx.default)(css.checkout, "mco-shop-checkout"),
      maxWidth: "lg"
    }, /*#__PURE__*/_react.default.createElement(_Addresses.default, {
      lang: lang,
      type: isGuest ? "guest" : null
    }));
  }
  if ((isGuest || isLoggedIn) && !(0, _isEmpty.default)(address) && !(0, _isEmpty.default)(paymentMethods) && !(0, _checkIfPaymentSelected.default)(paymentMethods)) {
    return /*#__PURE__*/_react.default.createElement(_Container.default, {
      className: (0, _clsx.default)(css.checkout, "mco-shop-checkout"),
      maxWidth: "lg"
    }, /*#__PURE__*/_react.default.createElement(_PaymentMethods.default, {
      defaultLang: lang
    }));
  }
  if ((isGuest || isLoggedIn) && (0, _checkIfPaymentSelected.default)(paymentMethods)) {
    return /*#__PURE__*/_react.default.createElement(_Container.default, {
      className: (0, _clsx.default)(css.checkout, "mco-shop-checkout"),
      maxWidth: "lg"
    }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Routes, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
      path: "addresses/:type/*",
      element: /*#__PURE__*/_react.default.createElement(_Addresses.default, {
        lang: lang
      })
    }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
      path: "payment",
      element: /*#__PURE__*/_react.default.createElement(_PaymentMethods.default, {
        defaultLang: lang
      })
    }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
      index: true,
      element: /*#__PURE__*/_react.default.createElement(_Overview.default, {
        defaultLang: lang
      })
    })));
  }
  if (!isLoggedIn && !isGuest) {
    return /*#__PURE__*/_react.default.createElement(_Login.default, {
      defaultLang: lang
    });
  }
  return /*#__PURE__*/_react.default.createElement(_Container.default, {
    className: (0, _clsx.default)(css.checkout, "mco-shop-checkout"),
    maxWidth: "lg"
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Routes, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: "addresses/:type/*",
    element: /*#__PURE__*/_react.default.createElement(_Addresses.default, {
      lang: lang
    })
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: "payment",
    element: /*#__PURE__*/_react.default.createElement(_PaymentMethods.default, {
      defaultLang: lang
    })
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    index: true,
    element: /*#__PURE__*/_react.default.createElement(Preloader, {
      defaultLang: lang
    })
  })));
};
Checkout01.propTypes = {
  defaultLang: _propTypes.default.string
};
var _default = exports.default = Checkout01;